import IconTooltip from 'modules/_shared/components/Icon/IconTooltip';
import { setModal } from 'modules/_shared/redux/modalActions';
import { getPartnerLink } from 'modules/partners/utils/getLinks';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { State } from 'redux/initialState';

import { CoOwner } from 'types';
import { formatNumberDecimals } from 'utils/formats';

type Props = {
  index: number;
  coOwner: CoOwner;
  isMainCoOwner?: boolean;
};

const ShareEncumbranceViewTableCoOwnerRow: FC<Props> = ({
  index,
  coOwner,
  isMainCoOwner,
}) => {
  const dispatch = useDispatch();

  const actualSociety = useSelector(
    (state: State) => state.society.actualSociety
  );

  const showPartnerLink = coOwner?.partner || isMainCoOwner;

  return (
    <div className="co-owner-row" key={`encumbrance-co-owner-${index}`}>
      <span className="fixed-width-percent">
        • {formatNumberDecimals(coOwner?.percent)}%
      </span>
      <span>
        &nbsp;|&nbsp;
        {showPartnerLink ? (
          <span onClick={() => dispatch(setModal(null))}>
            {getPartnerLink({
              societyId: actualSociety?._id || '',
              partnerId: coOwner?.partner || coOwner._id || '',
              partnerName: coOwner?.name,
            })}
          </span>
        ) : (
          coOwner?.name
        )}
      </span>

      {coOwner?.comment && (
        <IconTooltip
          id={coOwner?._id || coOwner?.partner || coOwner.cif}
          tooltip={coOwner.comment}
        />
      )}
    </div>
  );
};

export default ShareEncumbranceViewTableCoOwnerRow;
